import { takeEvery, fork, put, select } from 'redux-saga/effects';
import { HideDialog } from '@api/store/dialog/actions';
import { HideMediaManager } from '@api/store/mediaManager/actions';
import { ApplicationState as State } from '@api/store';
import { DialogState } from '@api/store/dialog/types';
import { MediaManagerState } from '@api/store/mediaManager/types';

const getDialog = (state: State): DialogState => state.dialog;
const getMediaManager = (state: State): MediaManagerState => state.mediaManager;

const POP_HISTORY_ACTION = 'POP';

function* closeDialog({ payload }: any): any {
    const dialog: DialogState = yield select(getDialog);
    const mediaManager: MediaManagerState = yield select(getMediaManager);

    if (dialog.isOpened && payload?.action !== POP_HISTORY_ACTION) {
        yield put(HideDialog());
    }

    if (mediaManager.isOpened) {
        yield put(HideMediaManager());
    }
}

function* watchLocationChangeRequest(): any {
    yield takeEvery('@@router/LOCATION_CHANGE', closeDialog);
}

const locationSagas = [fork(watchLocationChangeRequest)];

export default locationSagas;
